import { FTNodeOptions, ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";

/**
 * Necessary for Composition based rendering only. Normalizes options data across Composition and Template based rendering. Where there is overlap, data from the Composition will take precedence over flexTemplateNode.options. Useful for clientSideOnly modules and other components with no backing microservice, where Flex Compositor will put all moduleDefinition params into the model. Also useful for older components whose mock data for testing is based on Composition rendering
 * @param flexTemplateNode
 * @param model
 */
export const normalizeOptionsData = (flexTemplateNode: ExtendedFTNode, model: any): FTNodeOptions => {
  flexTemplateNode.options = {
    ...flexTemplateNode.options,
    ...model,
  };

  return flexTemplateNode.options;
};
